import React, { useEffect, useState, useRef, Fragment } from "react";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import DslDsMappingService from "./DslDsMappingService";
import { Table, TBody, TD, TH, THead, TR } from "../../Common/TableView";
import DataSourceService from "../../../services/DataSourceService";
import PaginationSM from '../../Common/PaginationSM';
import SortDirection from '../../Common/SortDirection';
import { Spinner } from "../../Common/Spinner";
import useSort from '../../../hooks/useSorting';
import { LinkFontAwesomeIcon } from "../../Common/ImageIcons";

function DslDsMappingForm(props) {
  let { current: scope } = useRef({ requestParams: {} });

  const {currentUser} = useCurrentUserHook();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [pagemeta, setPagemeta] = useState({});

  const {toggleModal, onSubmit, dsl} = props;
  
  useEffect(() => {
    setParams(1);
    getAll();
  }, [props.searchString])

  const setParams = (page) => {
    const requestParams = {
      'context': 'list',
      'page': page,
      'per_page': 15,
      'sort_column': scope.requestParams.sort_column || 'created_at',
      'sort_direction': scope.requestParams.sort_direction || 'desc',
      'search': props.searchString,
    }
    scope.requestParams = requestParams;
  }

  const onPageChage = (page) => {
    setParams(page);
    getAll();
  }

  const getAll = async () => {
    setLoading(true);
    const { status, data } = await DataSourceService.getDataSource(scope.requestParams);
    if (status === 200) {
      setList(data.data_sources);
      setPagemeta(data.meta);
    }
    setLoading(false);
  }

  const create = async (ds) => {
    const {status, data} = await DslDsMappingService.create({
      s_ds_id: dsl.data_source_id,
      s_dsl_id: dsl.id,
      t_ds_id: ds.id
    });
    if(status === 201){
      onSubmit(data);
      toggleModal();
    }
  }

  const SortDirIco = ({ column }) => {
    return (
      <SortDirection sortColumn={scope.requestParams.sort_column}
      column={column} reverse={scope.requestParams.reverse} />
    )
  }

  const { sort } = useSort(scope.requestParams, getAll);

  const tableData = list.map((o, k) =>
    <Fragment key={k}>
      <tr>
        <td className="text-center">
          {o.id}
        </td>
        <td className="text-center">
          {o.title}
        </td>
        <td className="flex aligncenter">
          <LinkFontAwesomeIcon
            tooltip="Update"
            onSelect={() => create(o)}
            iconCss="fas fa-plus-circle" />
        </td>
      </tr>
    </Fragment>
  )

  return (
    <div id="ct">
        <div className="app-content">
          <div className="app-header flex justspacebetween m-t-15">
            <div className="flex coldir">
              <div className="app-title m-r-20">Data SourceList</div>
              <div className="font-14">Total - {list.length}</div>
            </div>
            <div className="flex aligncenter">

            </div>
          </div>
          {loading ? <Spinner /> : null}
          <div className="app-content-section m-t-30 table-fix-head">
            <Table className="shadow-small">
              <THead>
                <TR>
                  <TH onClick={e => sort('id')}>
                    ID
                    <SortDirIco column="id" />
                  </TH>
                  <TH onClick={e => sort('title')}>
                    Label
                    <SortDirIco column="title" />
                  </TH>
                  <TH>
                    Action
                  </TH>
                </TR>
              </THead>
              <TBody>
                {tableData}
              </TBody>
            </Table>
          </div>

          <PaginationSM
            className="pagination-bar m-t-10"
            currentPage={parseInt(pagemeta.current_page)}
            totalItems={pagemeta.total || 0}
            itemsPerPage={pagemeta.per_page || 100}
            onPageChange={onPageChage}
            siblingCount={2} />

      </div>
    </div>
  )
  
}

export default DslDsMappingForm;